<app-autocomplete-field
  [label]="label()"
  [placeholder]="placeholder()"
  [errorMessage]="errorMessage()"
  [required]="required()"
  [disabled]="disabled()"
  [suggestions]="charities()"
  [optionLabel]="'value'"
  [ariaLabel]="'Charity'"
  [showCaretIcon]="true"
  [showClear]="false"
  [virtualScroll]="paged()"
  [lazy]="paged()"
  [virtualScrollItemSize]="44"
  [scrollHeight]="'320px'"
  (search)="onSearch($event)"
  (lazyLoad)="charityLoadMore.emit($event)"
  (optionSelect)="onSelect($event)"
>
  <ng-template #itemTemplate let-charity>
    <!-- POR-7071: identically-named funds from different Network Members must be distinguishable.
         Format agreed on the ticket: "{Fund Name} - {Fund Number}" (no Network Member). -->
    {{ charity.name }}
    @if (charity.fundNumberDisplay || charity.fundNumber) {
      - {{ charity.fundNumberDisplay || charity.fundNumber }}
    }
  </ng-template>
</app-autocomplete-field>
